import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_FOLLOWUPLIST,
  DELETE_FOLLOWUPLIST,
  UPDATE_FOLLOWUPLIST,
  ADD_NEW_FOLLOWUPLIST,
} from "./actionType";

import {
  getFollowupListSuccess,
  getFollowupListFail,
  deleteFollowupListSuccess,
  deleteFollowupListFail,
  updateFollowupListSuccess,
  updateFollowupListFail,
  addFollowupListSuccess,
  addFollowupListFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getFollowupListApi,
  updateFollowupListApi,
  deleteFollowupListApi,
  addNewFollowupListApi
} from "../../helpers/backend_helper";

function* getFollowupList({ payload: followupList }) {
  try {
    const response = yield call(getFollowupListApi, followupList);
    yield put(getFollowupListSuccess(GET_FOLLOWUPLIST, response.data));
  } catch (error) {
    yield put(getFollowupListFail(GET_FOLLOWUPLIST, error));
  }
}

function* onUpdateFollowupList({ payload: followupList }) {
  try {
    const response = yield call(updateFollowupListApi, followupList);
    yield put(updateFollowupListSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateFollowupListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteFollowupList({ payload: followupList }) {
  try {
    const response = yield call(deleteFollowupListApi, followupList);
    yield put(deleteFollowupListSuccess({ followupList, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteFollowupListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewFollowupList({ payload: followupList }) {
  try {
    const response = yield call(addNewFollowupListApi, followupList);
    yield put(addFollowupListSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addFollowupListFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetFollowupList() {
  yield takeEvery(GET_FOLLOWUPLIST, getFollowupList);
}

export function* watchUpdateFollowupList() {
  yield takeEvery(UPDATE_FOLLOWUPLIST, onUpdateFollowupList);
}

export function* watchDeleteFollowupList() {
  yield takeEvery(DELETE_FOLLOWUPLIST, onDeleteFollowupList);
}

export function* watchAddNewFollowupList() {
  yield takeEvery(ADD_NEW_FOLLOWUPLIST, onAddNewFollowupList);
}

function* followupListSaga() {
  yield all([
    fork(watchGetFollowupList),
    fork(watchDeleteFollowupList),
    fork(watchUpdateFollowupList),
    fork(watchAddNewFollowupList)
  ]);
}

export default followupListSaga;
